import useSyncedLocalStorage from "@avinet/adaptive-ui-core/hooks/useSyncedLocalStorage";
import Dialog from "@avinet/adaptive-ui-core/ui/Dialog";

const version = process.env.REACT_APP_VERSION ?? "dev";

export default function ReleaseNotes() {
  const [lastVersionDismissed, setDismissed] = useSyncedLocalStorage(
    "adaptive-survey-release-notes"
  );

  if (lastVersionDismissed === version) return null;

  return (
    <Dialog title="Release notes" onClose={() => setDismissed(version)}>
      <p>Welcome to Adaptive Survey! These are the latest changes.</p>
      <h3>v0.7.1</h3>
      <ul>
        <li>Introduced a new custom theme</li>
        <li>Add support for email input type in form</li>
      </ul>
      <div className="btn-group">
        <button
          type="button"
          className="btn"
          onClick={() => setDismissed(version)}
        >
          Got it!
        </button>
      </div>
    </Dialog>
  );
}
